/* eslint-disable max-len */
import React from "react";

const User = () => {
  return (
    <div>
      <h2>Hello User</h2>
      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse quaerat eligendi vero aut obcaecati, alias recusandae repudiandae in sed temporibus consectetur necessitatibus eos itaque aspernatur. Nulla, quae nisi maxime ipsum fugiat perspiciatis natus at! Tempora eaque ipsam illo suscipit excepturi consequatur quasi culpa esse beatae, explicabo voluptates animi quisquam, praesentium quis. Fugiat ad laborum vitae architecto illum, corporis officiis nesciunt saepe tempore eum minima aliquid accusantium nisi aliquam sapiente. Iste, ipsam saepe magnam sapiente ut soluta. Molestias doloribus doloremque, laboriosam possimus est optio fugit nulla dicta, mollitia pariatur sit a natus! Odio ullam incidunt adipisci accusamus nemo ea quasi fugiat?</p>
    </div>
  );
};

export default User;
